import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Skeleton from '@/enterprise/components/Skeleton';
import useEnableUnification from '@/enterprise/components/useEnableUnification';
import { ConsolidatedPendingClearsAlert } from '@/enterprise/features/history/PendingClearsAlert';
import QueryBoundaries from '@/shared/components/QueryBoundaries';

const ConsolidatedHistoryLayout = () => {
  const { t } = useTranslation();
  const enableUnification = useEnableUnification();

  return (
    <div className="space-y-6">
      <h1 className="m-0 pb-4 text-4xl">
        {enableUnification ? t('core.earlyPayHistory') : t('taker.consolidatedHistory.general')}
      </h1>
      <ConsolidatedPendingClearsAlert />
      <div className="overflow-hidden rounded-xl bg-white shadow-md">
        <QueryBoundaries LoadingComponent={() => <Skeleton className="h-80 w-full" />}>
          <Outlet />
        </QueryBoundaries>
      </div>
    </div>
  );
};

export default ConsolidatedHistoryLayout;
